module.exports = __webpack_public_path__ + "img/cura_add_postprocessing.941f9036.gif";